module.exports = __webpack_public_path__ + "images/Arrow 1-77cb9f33.png";


//////////////////
// WEBPACK FOOTER
// ./_assets/Arrow 1.png
// module id = 770
// module chunks = 0